<mdb-sidenav-item>
  <a [routerLink]="link()"
     [routerLinkActive]="'active'"
     (click)="onClick.emit()"
     class="sidenav-link d-flex justify-content-center fs-6 border-bottom"
     tabindex="0"
     mdbRipple>
    <span>{{text()|translate}}</span>
  </a>
</mdb-sidenav-item>
